import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const uploadContainer = document.getElementById("upload-status-container")

    addEventListener("direct-upload:initialize", event => {
      const { target, detail } = event
      const { id, file } = detail
      uploadContainer.insertAdjacentHTML("beforeend", `
        <div id="direct-upload-${id}" class="direct-upload direct-upload--pending">
          <div id="direct-upload-progress-${id}" class="direct-upload__progress" style="width: 0%"></div>
          <span class="direct-upload__filename"></span>
        </div>
      `)

      const progressBar = document.querySelector(`#direct-upload-${id} .direct-upload__filename`)

      if(progressBar) {
        progressBar.textContent = file.name
      }
    })

    addEventListener("direct-upload:start", event => {
      const { id } = event.detail
      const element = document.getElementById(`direct-upload-${id}`)
      element.classList.remove("direct-upload--pending")
    })

    addEventListener("direct-upload:progress", event => {
      const { id, progress } = event.detail
      const progressElement = document.getElementById(`direct-upload-progress-${id}`)
      progressElement.style.width = `${progress}%`
    })

    addEventListener("direct-upload:error", event => {
      event.preventDefault()
      const { id, error } = event.detail
      const element = document.getElementById(`direct-upload-${id}`)
      element.classList.add("direct-upload--error")
      element.setAttribute("title", error)
    })

    addEventListener("direct-upload:end", event => {
      const { id } = event.detail
      const element = document.getElementById(`direct-upload-${id}`)
      element.classList.add("direct-upload--complete")
    })
  }
}